import { render, staticRenderFns } from "./WsCompareMergeItem.vue?vue&type=template&id=e6dd55e8&"
import script from "./WsCompareMergeItem.vue?vue&type=script&lang=js&"
export * from "./WsCompareMergeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports